import {gql} from '@apollo/client'
import React from 'react'
import {TextInput} from '../../components/library/form'
import {FormModal} from '../../components/modals'
import {useStateChanged} from '../../hooks/use-state-changed'
import {useUpdateEnvironmentNameMutation} from './generated/edit-name-modal'

export const EditNameModal = ({
  environment,
  handleClose,
  onSaved
}: {
  environment: {id: string; name: string}
  handleClose: () => void
  onSaved: () => void
}) => {
  const [localObj, setLocalObj, dirty] = useStateChanged<{
    id: string
    name: string
  }>(environment)

  const [doMutation, {loading, error}] = useUpdateEnvironmentNameMutation({
    onCompleted: handleClose,
    refetchQueries: ['GetOrganisationAccess']
  })

  return (
    <FormModal
      title={'Edit ' + environment.name}
      handleClose={handleClose}
      onSubmit={async () => {
        await doMutation({
          variables: localObj
        })
        onSaved()
      }}
      error={error}
      isValid={dirty && !loading && !!localObj.name}
    >
      <TextInput
        label="Environment name"
        value={localObj.name || ''}
        onChange={name => setLocalObj(c => ({...c, name}))}
      />
    </FormModal>
  )
}

gql`
  mutation UpdateEnvironmentName($id: String!, $name: String!) {
    updateEnvironmentName(input: {environmentId: $id, name: $name}) {
      environment {
        ...EnvironmentDetail
      }
    }
  }
`
